<mat-form-field class="mat-dropdown">
  <mat-select
    data-cy="dashboard__cards__page_size_filter"
    (selectionChange)="filterPaginationPageSize($event)"
    [(value)]="selectedPageSize"
    >
    <mat-select-trigger>
      {{selectedPageSizeLabel}}
    </mat-select-trigger>
    @for (size of pageSizes; track size) {
      <mat-option
        [attr.data-cy]="'dashboard__cards__page_size_filter__option_' + size"
        [value]="size"
        >
        <span>
          {{size}} {{optionsSuffix}}
        </span>
      </mat-option>
    }

    <mat-option data-cy="dashboard__cards__page_size_filter__option_all" [value]="-1">
      All
    </mat-option>
  </mat-select>
</mat-form-field>
